"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const ItemRecommendationFragment_1 = __importDefault(require("../fragments/ItemRecommendationFragment"));
const ShowcasePaginationFragment_1 = __importDefault(require("../fragments/ShowcasePaginationFragment"));
const ShowcaseItemsQuery = (0, graphql_tag_1.default) `
  query showcaseItemsQuery(
    $showcaseId: String
    $customerId: String
    $placeId: String
    $pageId: String
    $partnerId: String
    $pmdPromoter: String
    $storeId: String
    $productId: String
    $filters: [FilterInput]
    $includePagination: Boolean = true
    $zipcode: String
    $offerOptions: OfferOptionsInput
  ) {
    recommendation(
      recommendationRequest: {
        customerId: $customerId
        pageId: $pageId
        placeId: $placeId
        productId: $productId
        metadata: {
          partnerId: $partnerId
          loyaltyParams: { pmdPromoter: $pmdPromoter, storeId: $storeId }
        }
        filters: $filters
        searchRequest: { location: { zipCode: $zipcode } }
      }
    ) {
      dynamic(showcaseId: $showcaseId) {
        id
        title
        type
        designTokenId
        items {
          ...item
        }
        button {
          label
        }
        pagination {
          ...pagination @include(if: $includePagination)
        }
      }
    }
  }
  ${ItemRecommendationFragment_1.default}
  ${ShowcasePaginationFragment_1.default}
`;
exports.default = ShowcaseItemsQuery;
